module.exports = __webpack_public_path__ + "static/media/preview_leads.2dfd3c1e.PNG";